import styled from "styled-components";

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;

export const Icon = styled.i`
  margin-right: 10px;
`;

export const FormContainer = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  background: linear-gradient(135deg, #2c3e35 0%, #1a2822 100%);
  padding: 2rem 2.5rem;
  color: #fff;

  @media (max-width: 768px) {
    padding: 1.5rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem 1rem;
  }
`;

export const HeaderTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

export const HeaderSubtitle = styled.p`
  font-size: 0.95rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const FormBody = styled.div`
  padding: 2.5rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }

  .row {
    @media (max-width: 480px) {
      margin-left: -0.25rem;
      margin-right: -0.25rem;

      &.justify-content-center {
        width: calc(100% + 0.5rem);
      }
    }
  }
`;

export const FormSection = styled.div`
  margin-bottom: 2rem;

  .form-control,
  .input-wrapper {
    width: 100%;
  }
`;

export const SectionLabel = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e35;
  margin-bottom: 0.5rem;

  ${(props) =>
    props.mandatory &&
    `
    &::after {
      content: " *";
      color: #dc3545;
    }
  `}
`;

export const HelpText = styled.p`
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  i {
    color: #f9ae17;
  }
`;

export const LocationsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const LocationPanel = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  /* overflow: hidden; */
  background: #fff;
`;

export const PanelHeader = styled.div`
  background: #f8f9fa;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
`;

export const ItemCount = styled.span`
  background: ${(props) => (props.selected ? "#f9ae17" : "#6c757d")};
  color: #fff;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
`;

export const SearchBox = styled.div`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;

  i {
    color: #6c757d;
    font-size: 0.9rem;
  }

  .search-input {
    border: none;
    outline: none;
    flex: 1;
    font-size: 0.9rem;
    color: #495057;
    background: transparent;

    &::placeholder {
      color: #adb5bd;
    }
  }
`;

export const LocationList = styled.div`
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

  .no-items,
  .no-items-selected {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #adb5bd;
    font-size: 0.9rem;
    text-align: center;
    padding: 2rem;
  }

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;

    &:hover {
      background: #a0aec0;
    }
  }
`;

export const LocationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f3f5;
  font-size: 0.9rem;
  color: #495057;
  transition: background-color 0.15s ease;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: #f8f9fa;
  }

  &:active {
    background-color: #e9ecef;
  }

  &:last-child {
    border-bottom: none;
  }

  span {
    flex: 1;
  }

  .action-btn {
    background: transparent;
    border: none;
    color: #6c757d;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    font-size: 0.85rem;
    transition: color 0.15s ease;

    &:hover {
      color: #f9ae17;
    }
  }
`;

export const TransferButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 0;
`;

export const TransferButton = styled.button`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: #495057;
  transition: all 0.15s ease;
  font-size: 1rem;

  &:hover:not(:disabled) {
    background: #f9ae17;
    border-color: #f9ae17;
    color: #fff;
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  i {
    display: block;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 0.75rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }
`;

export const CancelButton = styled.button`
  background: #6c757d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 150px;

  &:hover {
    background: #5a6268;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
    min-width: 120px;
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0.7rem 1rem;
    font-size: 0.85rem;
    min-width: unset;
  }
`;

export const ActionButton = styled.button`
  background: #f9ae17;
  color: #2c3e35;
  border: none;
  border-radius: 6px;
  padding: 1rem 2rem;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;

  &:hover {
    background: #e89d0f;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(249, 174, 23, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
    min-width: 150px;
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0.7rem 1rem;
    font-size: 0.85rem;
    min-width: unset;
  }
`;
